import React from "react";

function QtyButton({productQty, setProductQty}) {
        const qtyChange = (e) => {
            setProductQty(isNaN(e.target.value) ? 1 : e.target.value);
        },
        qtyMinus = () => {
            setProductQty(prevProductQty => prevProductQty > 0 ? parseInt(prevProductQty)-1 : 0 );
        },
        qtyPlus = () => {
            setProductQty(prevProductQty => parseInt(prevProductQty)+1);
        };
    return (
        <div className="qty-field">
            <button className="qty-button" onClick={qtyMinus}>-</button>
            <input name="productQty" type="text" value={productQty} onChange={qtyChange}/>
            <button className="qty-button" onClick={qtyPlus}>+</button>
        </div>
    )
}

export default QtyButton